import { View, Text } from "@react-pdf/renderer";
import { styles } from "../MemberDetailsStyle";

export default function FirstRow({ item }) {
  return (
    <View style={styles.firstRow.self}>
      {item.city && <Text style={styles.firstRow.city}>{item.city}</Text>}
      {item.name && <Text style={styles.firstRow.name}>{item.name}</Text>}
      {item.member_type && (
        <View style={{ ...styles.flex_container.self }}>
          <Text
            style={{
              ...styles.flex_container.fit_content,
              ...styles.flex_container.fit_content_first_item,
              ...styles.curved_borders,
              ...styles.primary,
            }}
          >
            {item.member_type}
          </Text>
          <Text style={styles.flex_container.empty_item}></Text>
        </View>
      )}
    </View>
  );
}
